module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_editor') === -1) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "md": 10,
      "lg": 7
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品名称",
      "size": "small"
    },
    model: {
      value: (_vm.params.keywords),
      callback: function($$v) {
        _vm.$set(_vm.params, "keywords", $$v)
      },
      expression: "params.keywords"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.goodsSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 7
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品编号",
      "size": "small"
    },
    model: {
      value: (_vm.params.item_bn),
      callback: function($$v) {
        _vm.$set(_vm.params, "item_bn", $$v)
      },
      expression: "params.item_bn"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.goodsSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-cascader', {
    attrs: {
      "size": "small",
      "placeholder": "商品产地",
      "options": _vm.regions,
      "clearable": ""
    },
    on: {
      "change": _vm.searchAction
    },
    model: {
      value: (_vm.select_regions_value),
      callback: function($$v) {
        _vm.select_regions_value = $$v
      },
      expression: "select_regions_value"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "请选择状态"
    },
    on: {
      "change": _vm.goodsSearch
    },
    model: {
      value: (_vm.params.approve_status),
      callback: function($$v) {
        _vm.$set(_vm.params, "approve_status", $$v)
      },
      expression: "params.approve_status"
    }
  }, _vm._l((_vm.statusOption), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "size": "mini",
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "商品类型"
    },
    on: {
      "change": _vm.searchAction
    },
    model: {
      value: (_vm.params.special_type),
      callback: function($$v) {
        _vm.$set(_vm.params, "special_type", $$v)
      },
      expression: "params.special_type"
    }
  }, _vm._l((_vm.special_type_list), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "placeholder": "商品类型",
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('shop-select', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "distributors": "",
      "shopIdDefault": _vm.params.distributor_id
    },
    on: {
      "update": _vm.goodsSearch
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-edit"
    },
    on: {
      "click": function($event) {
        return _vm.batchItemsAudit()
      }
    }
  }, [_vm._v("批量审核")])], 1)], 1)], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, _vm._l((_vm.tabList), function(item, index) {
    return _c('el-tab-pane', {
      key: index,
      attrs: {
        "label": item.name,
        "name": item.activeName
      }
    }, [_c('el-table', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.loading),
        expression: "loading"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.ItemsList,
        "height": _vm.wheight - 330
      },
      on: {
        "selection-change": _vm.handleSelectionChange
      }
    }, [_c('el-table-column', {
      attrs: {
        "type": "selection",
        "align": "center",
        "label": "全选"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "goods_id",
        "label": "商品ID",
        "width": "90"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "审核状态",
        "width": "100",
        "fixed": ""
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.rebate === 2) ? _c('el-tag', {
            attrs: {
              "size": "mini"
            }
          }, [_vm._v("等待审核")]) : _vm._e(), _vm._v(" "), (scope.row.rebate === 1) ? _c('el-tag', {
            attrs: {
              "size": "mini",
              "type": "success"
            }
          }, [_vm._v("通过审核")]) : _vm._e(), _vm._v(" "), (scope.row.rebate === 3) ? _c('el-tag', {
            attrs: {
              "size": "mini",
              "type": "warning"
            }
          }, [_vm._v("审核拒绝")]) : _vm._e()]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "商品图片",
        "width": "80"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-avatar', {
            attrs: {
              "shape": "square",
              "size": 60,
              "fit": "fit",
              "src": scope.row.pics[0]
            }
          })]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "规格",
        "width": "70"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(!scope.row.nospec) ? _c('el-tag', {
            attrs: {
              "effect": "plain",
              "type": "success"
            }
          }, [_vm._v("多规格")]) : _c('el-tag', {
            attrs: {
              "effect": "plain"
            }
          }, [_vm._v("单规格")])]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "itemName",
        "label": "商品名称"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v("\n              " + _vm._s(scope.row.item_name) + "\n              "), (scope.row.special_type == 'drug') ? _c('el-tag', {
            attrs: {
              "type": "danger",
              "size": "mini"
            }
          }, [_vm._v("处方药")]) : _vm._e()]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "销售价"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(" " + _vm._s(scope.row.price / 100) + "元 ")]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "成本价"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(" " + _vm._s(scope.row.cost_price / 100) + "元 ")]
        }
      }], null, true)
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "content-center content-top-padded"
    }, [_c('el-pagination', {
      attrs: {
        "background": "",
        "layout": "total, sizes, prev, pager, next",
        "current-page": _vm.params.page,
        "page-sizes": [10, 20, 50],
        "total": _vm.total_count,
        "page-size": _vm.params.pageSize
      },
      on: {
        "current-change": _vm.handleCurrentChange,
        "size-change": _vm.handleSizeChange,
        "update:currentPage": function($event) {
          return _vm.$set(_vm.params, "page", $event)
        },
        "update:current-page": function($event) {
          return _vm.$set(_vm.params, "page", $event)
        }
      }
    })], 1)], 1)
  }), 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "批量审核",
      "visible": _vm.dialogVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "审核状态"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.audit_status),
      callback: function($$v) {
        _vm.$set(_vm.form, "audit_status", $$v)
      },
      expression: "form.audit_status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "approved"
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "rejected"
    }
  }, [_vm._v("拒绝")])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-41e3ebb6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41e3ebb6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/popularize/goodsAudit.vue
// module id = 2664
// module chunks = 0